import React from 'react'
import Paper from 'material-ui/Paper';

import { promotions as ROLES_CONFIG } from '../../../../config/roles';
import NewPromotion from '../../../../components/promotions/NewPromotion';
import PromotionsList from '../../../../components/promotions/PromotionsList';

export default class Promotions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.create.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-5 col-11 ml-3-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <NewPromotion />
              </Paper> 
            : null
          }
          {
            ROLES_CONFIG.view.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-6 col-12 ml-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <PromotionsList />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/promotions/Promotions.js